import userApi from '@/api/user';

const SET_USERS = 'SET_USERS';
const ADD_USER = 'ADD_USER';
const UPDATE_USER = 'UPDATE_USER';
const DELETE_USER = 'DELETE_USER';

const state = {
  users: []
};

const getters = {
  getUsers: state => {
    return state.users;
  }
};

const mutations = {
  [SET_USERS] (state, users) {
    state.users = users;
  },
  [ADD_USER] (state, user) {
    state.users.push(user);
  },
  [UPDATE_USER] (state, user) {
    const index = state.users.map(e => e.id).indexOf(user);
    state.users.splice(index, 1, user);
  },
  [DELETE_USER] (state, userId) {
    const user = state.users.find(user => user.id === userId);
    user.enabled = false;
  }
};

const actions = {
  retrieveUsers ({commit}, {context}) {
    userApi.getUsers(context).then(users => {
      commit(SET_USERS, users);
    });
  },
  createUser ({commit}, {context, user}) {
    return new Promise((resolve, reject) => {
      userApi.createUser(context, user).then(user => {
        commit(ADD_USER, user);
        resolve();
      }, error => {
        reject(error);
      });
    });
  },
  updateUser ({commit}, {context, user}) {
    return new Promise((resolve, reject) => {
      userApi.updateUser(context, user).then(user => {
        commit(UPDATE_USER, user);
        resolve();
      }, error => {
        reject(error);
      });
    });
  },
  deleteUser ({commit}, {context, id}) {
    return new Promise((resolve, reject) => {
      userApi.deleteUser(context, id).then(() => {
        commit(DELETE_USER, id);
        resolve();
      }, error => {
        reject(error);
      });
    });
  },
  updateUserPassword ({commit}, {context, request}) {
    return new Promise((resolve, reject) => {
      userApi.updateUserPassword(context, request).then(() => {
        resolve();
      }, error => {
        reject(error);
      });
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js